<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import menuIcon from '@/assets/images/icons/vertical-dots-menu.svg?inline'

export default {
  name: 'events-table',
  components: {
    menuIcon
  },
  computed: {
    collection() {
      return this.$store.getters['events/getCollection']
    },
    ...mapGetters('account', [
      'checkEditEventsAccess'
    ])
  },
  methods: {
    getEventDates(dateFrom, dateTo) {
      return dateFrom
        ? `${moment.unix(dateFrom).format('DD.MM.YYYY')}-${moment.unix(dateTo).format('DD.MM.YYYY')}`
        : `${moment.unix(dateTo).format('DD.MM.YYYY')}`
    },
    openParticipationForm(eventData) {
      const {
        name,
        dateFrom,
        dateTo,
        id,
        type
      } = eventData

      this.$store.commit('events/setField', {
        target: 'participationForm.id',
        value: id
      })

      this.$store.commit('events/updateParticipationFormModal', {
        active: true,
        header: `${name} ${this.getEventDates(dateFrom, dateTo)}`,
        showPassportForm: type === 'Рекламный тур'
      })
    },
    openEditForm(id) {
      this.$store.dispatch('events/getEvent', id)

      this.$store.commit('events/updateEditFormModal', {
        active: true,
        isLoading: true,
        isNew: false
      })

      const isBitrixUsersLoaded = Boolean(this.$store.getters['events/getResponsibleUsers'].length)

      if (!isBitrixUsersLoaded) {
        this.$store.dispatch('events/getResponsibleUsers')
      }
    },
    showEventProgram(eventData) {
      const {
        name,
        dateFrom,
        dateTo,
        id
      } = eventData

      this.$store.dispatch('events/getEvent', id)

      this.$store.commit('events/updateProgramModal', {
        active: true,
        header: `${name} ${this.getEventDates(dateFrom, dateTo)}`,
        isLoading: true
      })
    },
    isEventEnded(eventEndTime) {
      return Number(moment.tz('Europe/Moscow').format('X')) > eventEndTime
    },
    remove(id) {
      this.$store.commit('events/setIsLoading', true)
      this.$store.dispatch('events/remove', id)
    }
  }
}
</script>
<template>
  <div class="events-table content-table">
    <b-table
      :data="collection"
      :row-class="(row, index) => 'orders-table__row'"
      :hoverable="true"
    >
      <template slot-scope="props">
        <b-table-column
          label="Название"
          :width="190"
        >
          <span class="events-table__event-name">
            {{ props.row.name }}
          </span>
        </b-table-column>
        <b-table-column
          label="Тип"
          :width="65"
        >
          <span class="events-table__event-content">
            {{ props.row.type }}
          </span>
        </b-table-column>
        <b-table-column
          label="Описание"
          :width="214"
        >
          <span class="events-table__event-content">
            {{ props.row.description }}
          </span>
        </b-table-column>
        <b-table-column
          label="Даты"
          :width="115"
        >
          <span class="events-table__event-content">
            {{ getEventDates(props.row.dateFrom, props.row.dateTo) }}
          </span>
        </b-table-column>
        <b-table-column
          label="Место"
          :width="95"
        >
          <span class="events-table__event-content">
            {{ props.row.place }}
          </span>
        </b-table-column>
        <b-table-column
          label="Стоимость"
          :width="115"
        >
          <span class="events-table__event-content">
            {{ props.row.price }}
          </span>
        </b-table-column>
        <b-table-column
          label=""
          :width="95"
        >
          <span class="events-table__event-content">
            <a
              href="javascript:;"
              @click="showEventProgram(props.row)"
            >
              Программа
            </a>
          </span>
        </b-table-column>
        <b-table-column>
          <template slot="header">
            <div />
          </template>
          <div class="events-table__controls">
            <div
              v-if="!isEventEnded(props.row.dateTo)"
            >
              <button
                v-if="props.row.status"
                class="
                  rex-button
                  rex-button--filled
                  rex-button--filled-red
                  rex-button--full-width
                  rex-button--small
                "
                @click="openParticipationForm(props.row)"
              >
                Участвую!
              </button>
              <span
                v-else
                class="events-table__event-content"
              >
                Набор закрыт
              </span>
            </div>
            <div
              v-else
            >
              <span
                class="events-table__event-content"
              >
                Мероприятие завершено.
                <a
                  v-if="props.row.report"
                  :href="props.row.report"
                  target="_blank"
                >
                  Отчет
                </a>
              </span>
            </div>
            <b-dropdown
              v-if="checkEditEventsAccess"
              position="is-bottom-left"
              :hoverable="true"
            >
              <button
                slot="trigger"
                class="events-table__menu"
              >
                <menu-icon
                  fill="#ababab"
                />
              </button>
              <b-dropdown-item
                :focusable="false"
                @click="remove(props.row.id)"
              >
                Удалить
              </b-dropdown-item>
              <b-dropdown-item
                :focusable="false"
                @click="openEditForm(props.row.id)"
              >
                Изменить
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>